import { FC, useCallback } from 'react'
import {
    components,
    IndicatorContainerProps,
    InputProps,
    OptionProps,
    OptionTypeBase,
    SingleValueProps,
    Props as SelectProps,
} from 'react-select'
import styled from '@emotion/styled'

import StyledReactSelect from '@/components/Form/components/styles/StyledReactSelect'

type TOption = {
    value: any
    label: string
    icon: any
}

const IndicatorOuterContainer = styled.div`
    display: flex;
`

const IndicatorOptionIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const SelectOptionLayout = styled.div`
    display: flex;
    gap: 1rem;
`

type TSelectWithIconIndicator = SelectProps<OptionTypeBase> & {
    selectedOption: TOption
    id: any
    placeholder: string
    options: any[]
    name: string
    onChange: (option: any) => void
    CustomOptionLayout?: FC<OptionProps<object, true>>
    CustomInput?: FC<InputProps>
    CustomSingleValue?: FC<SingleValueProps<any>>
}

const SelectWithIconIndicator: FC<TSelectWithIconIndicator> = ({
    selectedOption,
    id,
    placeholder,
    options,
    name,
    onChange,
    CustomOptionLayout,
    CustomInput,
    CustomSingleValue,
    ...props
}) => {
    const { icon: selectedOptionIcon } = selectedOption ?? {}

    const IndicatorsContainer = useCallback(
        (indicatorProps: IndicatorContainerProps<{}, true>) => (
            <IndicatorOuterContainer>
                <IndicatorOptionIcon>{selectedOptionIcon}</IndicatorOptionIcon>
                <components.IndicatorsContainer {...indicatorProps} />
            </IndicatorOuterContainer>
        ),
        [selectedOptionIcon],
    )

    const Option = useCallback(
        (optionProps: OptionProps<{}, true>) => {
            const { data, ...rest } = optionProps
            const { icon: optionIcon, label } = data

            return (
                <components.Option {...optionProps}>
                    {CustomOptionLayout ? (
                        <CustomOptionLayout {...optionProps} />
                    ) : (
                        <SelectOptionLayout>
                            <span>{optionIcon}</span>
                            <span>{label}</span>
                        </SelectOptionLayout>
                    )}
                </components.Option>
            )
        },
        [CustomOptionLayout],
    )

    const customComponents = {
        IndicatorsContainer,
        Option,
        ...(CustomInput && { Input: CustomInput }),
        ...(CustomSingleValue && { SingleValue: CustomSingleValue }),
    }

    return (
        <StyledReactSelect
            // @ts-ignore
            components={customComponents}
            classNamePrefix="Select"
            id={id}
            placeholder={placeholder}
            options={options}
            name={name}
            value={selectedOption}
            // @ts-ignore
            onChange={onChange}
            {...props}
        />
    )
}

export { SelectOptionLayout }
export default SelectWithIconIndicator
